import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import { DatePipe } from '@angular/common';
import { MaeCorreoE} from 'src/app/model/mae-correo-bean';
import { Response_dml_bean } from 'src/app/model/response-dml';
import { AngularEditorConfig } from "@kolkov/angular-editor";

import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { GlobalVariablesService } from 'src/app/service/global-variables.service';
import { MaeCorreoService } from 'src/app/service/mae-correo.service';

import { CorreoPruebaComponent } from 'src/app/pagina-admin/dashboard/gestion-correo/correo-prueba/correo-prueba.component';

@Component({
  selector: 'app-gestion-correo',
  templateUrl: './gestion-correo.component.html',
  styleUrls: ['./gestion-correo.component.scss']
})
export class GestionCorreoComponent implements OnInit {

  constructor(
    private utilitarioService:UtilitarioService,
    private globalVariablesService: GlobalVariablesService,
    private maeCorreoService:MaeCorreoService,
    private modalService: MDBModalService,
    ){}

  contador = 0;
  limite_carac = 3000;
  maeCorreoE = new MaeCorreoE();
  x_mensaje:String;
  htmlContent:String;
  parametros = new Array<string>();


  //modal
  modalRefCorreoPruebaDml: MDBModalRef;

  ngOnInit(): void {
    this.cargarDatoInicial();
/*
    this.maeCorreoE.x_asunto = "Evaluación de Convenio";
    this.maeCorreoE.x_mensaje = "<div>Es grato dirigirme a usted, con relaci&#243;n a lo dispuesto en la <b>Directiva de Convenios</b> vigente, y solicitar la evaluaci&#243;n y registro de la informaci&#243;n referida a la ejecuci&#243;n de convenios suscritos, correspondiente al <b>&#34;$CONVENIO$&#34;</b>, en cumplimiento con el numeral 8.5 de la citada Directiva y Manual de Procedimientos E01 - Gesti&#243;n Estrat&#233;gica.</div><div><br></div><div>Para este fin, deber&#225; realizar el registro de evaluaci&#243;n en el Sistema de Convenios, a trav&#233;s del siguiente link:&#160;<a href=\"https://convenios.bnp.gob.pe/#/\" target=\"_blank\">https://convenios.bnp.gob.pe/#/</a>&#160;e indicar lo siguiente:</div><div><br></div><div><ul><li>El nivel de avance en la ejecuci&#243;n de los compromisos asumidos.</li><li>Detallar las actividades realizadas como parte del convenio.</li><li>Logros alcanzados y la problem&#225;tica encontrada que pueda afectar la ejecuci&#243;n del convenio.</li><li>Adjuntar informaci&#243;n o evidencia de lo sustentado</li></ul></div><div><span>El mencionado registro en el Sistema de Convenios deber&#225; ser concluido y enviado en un plazo m&#225;ximo de siete (07) d&#237;as h&#225;biles de recibido este correo.</span><br></div>";
    this.maeCorreoE.x_parametros = "$CONVENIO$,$CORRELATIVO$";
*/
  }

  cargarDatoInicial()
  {
    this.utilitarioService.loading = true;

    const cargarCorreo = this.maeCorreoService.get().toPromise()
      .then(result => {
        this.maeCorreoE = result[0];
        this.parametros = this.maeCorreoE.x_parametros.split(",");
      });

      Promise.all([cargarCorreo])
      .then(response => {
        this.utilitarioService.loading = false;
      })
      .catch(error => console.log(`Error in executing ${error}`));
  }

  onGuardar()
  {
    if (this.validarFormulario()==false){
      return false;
    }
    this.utilitarioService.loading=true;


    //this.maeCorreoE.serviceCredencialesM = this.globalVariablesService.getCredencialesConvenio();
    this.maeCorreoE.auditoriaBeanM = this.globalVariablesService.getAuditoriaServicio('U');
    console.log(this.maeCorreoE);
    this.maeCorreoService.proceDml(this.maeCorreoE).subscribe((result:Response_dml_bean)=>{
      console.log(result);
      this.utilitarioService.loading=false;
      if (result.codigoRespuestaServicio=="1"){
        this.utilitarioService.toastrSuccess(result.mensaje);
      }else{
        this.utilitarioService.toastrError(result.mensaje);
      }
    });
  }


  onProbarEnvio(){

    var datePipe = new DatePipe("en-US");
    var hoy = new Date();
    var hoy_text = datePipe.transform(hoy, 'yyyy-MM-dd');
    this.modalRefCorreoPruebaDml = this.modalService.show(CorreoPruebaComponent,
      {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: false,
        class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable modal-notify modal-warning modal-lg',
        containerClass: 'top',
        animated: true,
        data: {
          x_asunto:'Correo Prueba '+hoy_text+':'+this.maeCorreoE.x_asunto,
        }
      }
    );

  }

  validarFormulario() : Boolean{
    //valida formulario
    if (this.globalVariablesService.getC_usuario.toString()==null){
      this.utilitarioService.toastrError("Su session ha culminado, ingrese nuevamente al sistema.");
      return false;
    }

    //valida tamaño de asunto
    if (this.maeCorreoE.x_asunto=="" || this.maeCorreoE.x_asunto==null){
      this.utilitarioService.toastrError("Ingrese el asunto del correo.");
      return false;
    }

    //valida mensaje
    if (this.maeCorreoE.x_mensaje=="" || this.maeCorreoE.x_mensaje==null){
      this.utilitarioService.toastrError("Ingrese el asunto del correo.");
      return false;
    }
    else
    {
      if(this.contador>this.limite_carac)
      {
        this.utilitarioService.toastrError("El mensaje excede el limite de caracteres");
        return false;
      }
      // se verifica q contenga todos los parametros
      for (let i = 0; i < this.parametros.length; i++)
        if (!this.maeCorreoE.x_mensaje.includes(this.parametros[i]))
        {
          this.utilitarioService.toastrError("El mensaje debe contener el parametro : "+this.parametros[i]);
          return false;
        }
    }

    return true;
  }

  onKey(event){
    this.contador = this.maeCorreoE.x_mensaje.length;
  }
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "300px",
    minHeight: "0",
    maxHeight: "auto",
    width: "auto",
    minWidth: "0",
    translate: "yes",
    enableToolbar: true,
    showToolbar: true,
    placeholder: "Ingrese el mensaje aqui...",
    defaultParagraphSeparator: "",
    defaultFontName: "",
    defaultFontSize: "",
    fonts: [
      { class: "arial", name: "Arial" },
      { class: "times-new-roman", name: "Times New Roman" },
      { class: "calibri", name: "Calibri" },
      { class: "comic-sans-ms", name: "Comic Sans MS" },
    ],
    sanitize: false,
    toolbarPosition: "top",
    toolbarHiddenButtons: [["strikeThrough", "subscript","superscript","heading",'fontName',],
                          [//"fontSize",
                          "textColor",
                          "backgroundColor",
                          "customClasses",
                          //"unlink",
                          "insertImage",
                          "insertVideo",
                          "insertHorizontalRule",
                          "removeFormat",
                          "toggleEditorMode",]],
  };
}
